import React from "react";
import { Hash, Shield, EyeOff } from "lucide-react";

export function EvidenceChip({ refId, label, hash, shared = true }) {
  const display = (hash || "").replace(/^sha256:/, "").slice(0, 12);
  return (
    <span className="evidence-chip" data-testid={`evidence-chip-${refId}`}>
      {shared ? <Shield size={12} /> : <EyeOff size={12} />}
      <span className="text-[10.5px] tracking-[0.14em] uppercase text-[var(--ink-mono)] font-medium">
        {refId}
      </span>
      <span className="text-[var(--ink-secondary)]">{label}</span>
      <span className="text-[var(--ink-muted)] flex items-center gap-1">
        <Hash size={10} />
        {display}…
      </span>
    </span>
  );
}

export function HashChip({ value, label }) {
  if (!value) return null;
  const trimmed = String(value).replace(/^sha256:/, "");
  return (
    <span className="evidence-chip" data-testid={`hash-chip-${label || "hash"}`}>
      {label && (
        <span className="text-[10.5px] tracking-[0.14em] uppercase text-[var(--ink-mono)] font-medium">
          {label}
        </span>
      )}
      <span className="text-[var(--ink-secondary)]">{trimmed.slice(0, 16)}…{trimmed.slice(-6)}</span>
    </span>
  );
}
